<template>
    <tr>
        <th class="line-heading">
            <i class="mi drag_handle float-left"></i>
            <input type="text" class="form-control" v-model="newUserStory.title" @change="handleCreateUserStory" placeholder="Add new...">
        </th>
        <td>
            <input type="text" class="form-control" value="">
        </td>
        <td>
            <input type="text" class="form-control" value="">
        </td>
        <td>
            <input type="text" class="form-control" value="">
        </td>
        <td class="strong"></td>
        <td></td>
        <td class="cost"><span class="float-left"></span> </td>
        <td class="options">
            
        </td>
    </tr>
</template>

<script>
    //http://stackoverflow.com/documentation/javascript/4742/same-origin-policy-cross-origin-communication/30128/safe-cross-origin-communication-with-messages#t=201705171403471400655
//<div id="iframe-wrapper" style="position: absolute; width: 100%; height: 100%; top: 0px; background-color: #c3c3c3; z-index: 1000; opacity: 0.4;"><i class="fa fa-sticky-note" style=" font-size: 24px; z-index: 1005; position: absolute; top: 100px; left: 100px; color: red;"></i></div>
	import { mapState, mapActions } from 'vuex'
	import { Selectize, LaddaButton } from 'components/form/input'
    import Datepicker from 'vuejs-datepicker'
	import { notify } from 'utils'
	import CostingLine from 'components/opportunities/CostingLine.vue'
	import CreateUserStory from './CreateUserStory.vue'
	import draggable from 'vuedraggable'

	import Story from './../../models/story.js'
  	import Epic from './../../models/epic.js'

    export default {
        components: {
            LaddaButton,
            Datepicker,
			Selectize,
			draggable,
			CostingLine,
			CreateUserStory
        },
        props: ['epic_id', 'user_story_document_id', 'order'],
        data: function () {
            return {
				newUserStory: new Story(),
            }
        },
        methods: {
            ...mapActions('epics', ['addUserStory']),

            handleCreateUserStory () {

				this.newUserStory.epic_id = this.epic_id
				this.newUserStory.order = this.order
				//this[SET_SAVE_STATUS](AppConstants.save_status.SAVING)

				this.addUserStory({
					id: this.user_story_document_id,
					index: this.order,
					payload: this.newUserStory
				}).then((response) => {

					//reset the form data
                    this.newUserStory = new Story()
                    
                    this.$bus.$emit('reload');
                    
					//this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
				}).catch((response) => {
					notify.error('There was an issue trying to create your user story!')
					//this[SET_SAVE_STATUS](AppConstants.save_status.ERROR_SAVING)
				})
			},
        }
    }
</script>
